import { createFileRoute } from '@tanstack/react-router'
import { TicketTemplate } from '@/components/settings-route/ticket/ticket-template/index.jsx'

export const Route = createFileRoute('/_auth/settings/tickets/template')({
  component: TicketTemplate,
})
